window.setTimeout(() => {
	// Only runs in webcams menu and if window width is < 30em
	if (
		WC.idMenu !== 38 ||
		!('matchMedia' in window) ||
		window.matchMedia('(min-width: 30em)').matches
	) {
		return
	}

	const gallery = document.querySelector('.gallery-cnt.gallery-ordinata-cnt')
	const columns = gallery.querySelectorAll('.colonnaFoto')
	const elements = []

	columns.forEach(column => {
		const childs = column.querySelectorAll('.gallery-foto-cnt')
		let lastOrder = 0
		childs.forEach((child, index) => {
			let order = null
			const wcOrder = child.querySelector('.gallery-foto-link')?.dataset?.wcOrder

			if (wcOrder) {
				order = parseInt(wcOrder)
				lastOrder = order
			} else {
				order = lastOrder + index / 100
			}

			elements.push({
				order,
				node: child,
			})
		})
	})

	const newColumn = document.createElement('div')
	newColumn.classList.add('colonnaFoto')
	const newColumnFotoGal = document.createElement('div')
	newColumnFotoGal.classList.add('fotoGal')
	newColumn.appendChild(newColumnFotoGal)

	elements
		.sort((a, b) => a.order - b.order)
		.forEach(element => {
			newColumnFotoGal.appendChild(element.node)
		})

	gallery.innerHTML = ''
	gallery.appendChild(newColumn)
}, 200)
